// TODO - duplicate menu is bad

function MenuSenat() {
    return (
        <div id="menu">
            <ul>
                <li><a href="#sejm">Wybory do Sejmu</a></li>
                <li><a href="#" id="menuClicked">Wybory do Senatu</a></li>
                <li><a href="#info">Informacje</a></li>
            </ul>
        </div>
    )
}

export default MenuSenat;